define('home/views/SettingsAccountView',[
    'backbone-marionette',

    'core/utils/url/parseQueryString',

    'home/mixins/withSubviews',
    'home/templates/settingsAccount',
    'home/views/SettingsAccountFormView',
    'home/views/SettingsConnectedAccountsView',
    'home/views/SettingsDeleteFormView',
], function (
    Marionette,

    parseQueryString,

    withSubviews,
    settingsAccountTemplate,
    SettingsAccountFormView,
    SettingsConnectedAccountsView,
    SettingsDeleteFormView
) {
    'use strict';

    var SettingsAccountView = Marionette.ItemView.extend({
        template: settingsAccountTemplate,

        regions: {
            connectedAccountsRegion: '[data-role=connected-accounts]',
            formRegion: '[data-role=account-form]',
            deleteRegion: '[data-role=delete-form]',
        },

        templateHelpers: function () {
            return {
                showVerifiedMessage: this.showVerifiedMessage(),
            };
        },

        initialize: function (options) {
            this.session = options.session;
        },

        /**
         * Users are redirected to /home/settings/account/?email_verified=1 after verifying their email.
         * This method returns true if location.search contains email_verified=1.
         *
         * TODO: Remove this when users are directed to discover page after email confirmation
         */
        showVerifiedMessage: function () {
            return Boolean(parseQueryString().email_verified);
        },

        onRender: function () {
            this.activateRegion(this.connectedAccountsRegion, this.createConnectedAccountsView);
            this.activateRegion(this.formRegion, this.createFormView);
            this.activateRegion(this.deleteRegion, this.createDeleteFormView);
        },

        createFormView: function () {
            return new SettingsAccountFormView({
                el: this.formRegion.el,
                model: this.model,
            });
        },

        createDeleteFormView: function () {
            return new SettingsDeleteFormView({
                el: this.deleteRegion.el,
                session: this.session,
            });
        },

        createConnectedAccountsView: function () {
            return new SettingsConnectedAccountsView({
                el: this.connectedAccountsRegion.el,
                collection: this.model.socialAccounts,
            });
        },

    });

    withSubviews.call(SettingsAccountView.prototype);

    return SettingsAccountView;
});

